import {useContext} from 'react'
import Helmet from 'react-helmet';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import {  LanguageContext } from '../context';
import Developer from '../StaticPages/Developer/Developer';
import MetaTags from '../Components/MetaTags/MetaTags';

const DeveloperPage = () => {

    const { language } = useContext(LanguageContext);
    return (
      <div>
        <MetaTags title={"Developer Page"} description={"Developer Page"}/>
         
        
        <Header/>
        <Developer/>
      
        
      
     
          <Footer/>
  
      </div>
    )
  }

export default DeveloperPage